import { inject, NewInstance } from 'aurelia-framework';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), UnitOfMeasurementService, EventAggregator)
export class UnitOfMeasurementEditor {
    constructor(controller, validationController, unitOfMeasurementService, ea) {
        this.controller = controller;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.ea = ea;
        this.unitOfMeasurement = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.unitOfMeasurement = await this.unitOfMeasurementService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.unitOfMeasurement.id) {
                    await this.unitOfMeasurementService.update(this.unitOfMeasurement);
                    toastr.success('Unit of measurement was updated!');
                } else {
                    await this.unitOfMeasurementService.create(this.unitOfMeasurement);
                    toastr.success('New unit of measurement was created!');
                }
                this.ea.publish('unit-of-measurements:updated', this.unitOfMeasurement);
                this.controller.ok(this.unitOfMeasurement);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}